import { Link, useNavigate } from "react-router-dom";
import ISiteDiaryStaffOnSite from "interfaces/SiteDiary/StaffOnSite/ISiteDiaryStaffOnSite";
import { PencilSquare } from "react-bootstrap-icons";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IEditStaffOnSiteRequestModel from "interfaces/Request/IEditStaffOnSiteRequestModel";
import { convertToDateFromLocalDate } from "helpers/DateUtils";

const EditTemplate = (props: ISiteDiaryStaffOnSite): any => {
  const {
    hwrcSiteId,
    diaryDate,
    name,
    id,
    notes,
    timeIn,
    timeOut,
    cotcQualified
  } = props;
  // eslint-disable-next-line max-len
  const editUrl = `${RoutePathsEnum.SiteDiaryEditStaffOnSite}/${hwrcSiteId}/${diaryDate}`;

  const timeInwithDate = convertToDateFromLocalDate(diaryDate!);

  if (timeIn !== undefined && timeIn !== null) {
    const timeInDate = new Date(timeIn);
    if (!Number.isNaN(timeInDate.getTime())) {
      timeInwithDate.setHours(timeInDate.getHours());
      timeInwithDate.setMinutes(timeInDate.getMinutes());
    }
  }

  let timeOutWithDate;

  if (timeOut !== null && timeOut !== undefined) {
    const timeOutDate = new Date(timeOut!);
    if (!Number.isNaN(timeOutDate.getTime())) {
      timeOutWithDate = convertToDateFromLocalDate(diaryDate!);
      timeOutWithDate.setHours(timeOutDate.getHours());
      timeOutWithDate.setMinutes(timeOutDate.getMinutes());
    }
  }

  const editDetails: IEditStaffOnSiteRequestModel = {
    id,
    name,
    timeIn: timeInwithDate.toISOString(),
    timeOut: timeOutWithDate ? timeOutWithDate.toISOString() : undefined,
    notes,
    cotcQualified
  };

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };

  return (
    <>
      <Link to={editUrl} state={editDetails} onContextMenu={handleContextMenu}>
        <PencilSquare data-testid={`edit-${id}`} color="#000" />
        <span className="visually-hidden">
          edit
          {name}
        </span>
      </Link>
    </>
  );
};
export default EditTemplate;
